var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloseTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 15,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7.5,
  r: 7,
  fill: "#3263E9"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m9.5 5-5 5m5 0-5-5",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgCloseTag;